module.exports = __webpack_public_path__ + "static/fonts/Montserrat900.e3242149.ttf";